/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import * as Yup from 'yup'
import clsx from 'clsx'
import * as Auth from '../redux/AuthRedux'
import * as Search from '../../searchFilter/redux/SearchFilterRedux'
import { useFormik } from 'formik'
import { login } from '../redux/AuthCRUD'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'


const loginSchema = Yup.object().shape({
  username: Yup.string()
    .required('Username is required'),
  systemid: Yup.string()
    .required('Instance is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

const initialValues = {
  username: '',
  password: '',
  systemid: ''
}

export function Login() {
  const dispatch = useDispatch()
  const [errMsg, setErrMsg] = useState('');
  const [loading, setLoading] = useState(false)
  const [checkgoogle, setCheckgoogle] = useState<boolean>(false);
  const intl = useIntl()
  const history = useHistory();

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      setTimeout(() => {
        login({ username: values.username, password: values.password, instance: values.systemid })
          .then((response) => {
            setLoading(false)
            let { data } = response;
            if (data?.code !== 1) {
              setSubmitting(false)
              setStatus('The login detail is incorrect')
            } else {
              dispatch(Search.actions.setCompanyId(values.systemid));
              dispatch(Auth.actions.login(data));
              let user: any = JSON.parse(data.userdata);
              if (user.otpvalid24h) { 
                dispatch(Auth.actions.setSessionId(user.apipw));
              } else {
                history.push('/auth/otplogin')
              }

            }
          })
          .catch((err) => {
            setLoading(false)
            setSubmitting(false)
            setStatus('The login detail is incorrect')
          })
      }, 1000)
    },
  })

  return (

    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
    >
      <div className={checkgoogle ? `overlay overlay-block rounded` : ''}>
        <div className={checkgoogle ? `overlay-wrapper` : ''}>
          {/* begin::Heading */}
          <div className='d-flex justify-content-center align-items-center mb-10'>
            {/* <span>
              <img
                alt='db'
                src={toAbsoluteUrl('/media/logos/logo-1.svg')}
                className='h-65px'
              />
            </span> */}
            <div className='text-center pt-3'>
              <h1 id='login_page_title' className='text-dark'>&nbsp;&nbsp;{intl.formatMessage({ id: 'AUTH.LOGIN' })}</h1>
            </div>
          </div>
          {/* begin::Heading */}
          {formik.status ? (
            <div className='mb-lg-15 alert alert-danger'>
              <div id='login_error_msg' className='alert-text font-weight-bold'>{formik.status}</div>
            </div>
          ) : (
            <></>
          )}
          {errMsg.length > 0 ? (
            <div className='mb-lg-15 alert alert-danger'>
              <div className='alert-text font-weight-bold'>{errMsg}</div>
            </div>
          ) : (
            <></>
          )}

          {/* begin::Form group */}
          <div className='fv-row mb-10'>
            {/* <label className='form-label fs-6  text-dark'>Instance</label> */}
            <div className='d-flex justify-content-center align-items-center'>
              <span className="w-50px">
                <img
                  alt='db'
                  src={toAbsoluteUrl('/media/icons/duotune/abstract/abs027.svg')}
                  className='h-30px'
                />
              </span>
              <div className='w-100'>
                <input
                  placeholder={intl.formatMessage({ id: 'AUTH.INSTANCE' })}
                  type='text'
                  id='systemid'
                  autoComplete='off'
                  {...formik.getFieldProps('systemid')}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    { 'is-invalid': formik.touched.systemid && formik.errors.systemid },
                    {
                      'is-valid': formik.touched.systemid && !formik.errors.systemid,
                    }
                  )}
                />

                {formik.touched.systemid && formik.errors.systemid && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block text-danger'>
                      <span role='alert'>{formik.errors.systemid}</span>
                    </div>
                  </div>
                )}
              </div>

            </div>
          </div>
          {/* end::Form group */}
          {/* begin::Form group */}
          <div className='fv-row mb-10'>
            {/* <label className='form-label fs-6  text-dark'>Email</label> */}
            <div className='d-flex justify-content-center align-items-center'>
              <span className="w-50px">
                <img
                  alt='db'
                  src={toAbsoluteUrl('/media/icons/duotune/general/gen049.svg')}
                  className='h-30px'
                />
              </span>
              <div className='w-100'>
                <input
                  placeholder={intl.formatMessage({ id: 'AUTH.USERNAME' })}
                  type='username'
                  id='login_email'
                  autoComplete='off'
                  {...formik.getFieldProps('username')}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    { 'is-invalid': formik.touched.username && formik.errors.username },
                    {
                      'is-valid': formik.touched.username && !formik.errors.username,
                    }
                  )}
                />
                {formik.touched.username && formik.errors.username && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block text-danger'>
                      <span role='alert'>{formik.errors.username}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* end::Form group */}

          {/* begin::Form group */}
          <div className='fv-row mb-10'>
            <div className='d-flex justify-content-between mt-n5'>
              <div className='d-flex flex-stack mb-2'>
                {/* begin::Label */}
                {/* <label className='form-label  text-dark fs-6 mb-0'>Password</label> */}
                {/* end::Label */}
              </div>
            </div>
            <div className='d-flex justify-content-center align-items-center'>
              <span className="w-50px">
                <img
                  alt='db'
                  src={toAbsoluteUrl('/media/icons/duotune/general/gen047.svg')}
                  className='h-30px'
                />
              </span>
              <div className='w-100'>
                <input
                  type='password'
                  placeholder={intl.formatMessage({ id: 'AUTH.PASSWORD' })}
                  id='login_password'
                  autoComplete='off'
                  {...formik.getFieldProps('password')}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {
                      'is-invalid': formik.touched.password && formik.errors.password,
                    },
                    {
                      'is-valid': formik.touched.password && !formik.errors.password,
                    }
                  )}
                />
                {formik.touched.password && formik.errors.password && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block text-danger'>
                      <span role='alert'>{formik.errors.password}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* end::Form group */}

          {/* begin::Action */}
          <div className='text-center'>
            <button
              type='submit'
              id='login_submit'
              className='btn btn-lg btn-primary w-100 mb-5'
              disabled={formik.isSubmitting || !formik.isValid}
            >
              {!loading && <span className='indicator-label'>{intl.formatMessage({ id: 'AUTH.CONTINUE' })}</span>}
              {loading && (
                <span className='indicator-progress' style={{ display: 'block' }}>
                  {intl.formatMessage({ id: 'MENU.WAIT' })}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
          {/* end::Action */}
          {
            checkgoogle ? (<div className="overlay-layer rounded bg-white bg-opacity-75">
              <div
                className="spinner-border text-primary"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>) : (<></>)
          }
        </div>
      </div>
    </form >
  )
}
